module.exports = __webpack_public_path__ + "static/how_are_emotions-03b8f0c61d22b2151a10c10c3ef198ae.png";